import { useLocale, useTranslations } from "next-intl";

export function useTranslatedData() {
  const t = useTranslations();
  const locale = useLocale();

  const navItems = [
    { name: t("navItems.0.name"), link: `/${locale}/services` },
    { name: t("navItems.1.name"), link: `/${locale}/gallery` },
    { name: t("navItems.2.name"), link: `/${locale}#partners` },
    { name: t("navItems.3.name"), link: `/${locale}/contact-us` },
  ];

  const gridItems = [
    {
      id: 1,
      title: t("gridItems.0.title"),
      description: t("gridItems.0.description"),
      className: "lg:col-span-3 md:col-span-6 md:row-span-4 lg:min-h-[60vh]",
      imgClassName: "w-full h-full",
      titleClassName: "justify-end",
      img: "/b1.svg",
      spareImg: "",
    },
    {
      id: 2,
      title: t("gridItems.1.title"),
      description: t("gridItems.1.description"),
      className: "lg:col-span-2 md:col-span-3 md:row-span-2",
      imgClassName: "",
      titleClassName: "justify-start",
      img: "",
      spareImg: "",
    },
    {
      id: 3,
      title: t("gridItems.2.title"),
      description: t("gridItems.2.description"),
      className: "lg:col-span-2 md:col-span-3 md:row-span-2",
      imgClassName: "",
      titleClassName: "justify-center",
      img: "",
      spareImg: "",
    },
    {
      id: 4,
      title: t("gridItems.3.title"),
      description: t("gridItems.3.description"),
      className: "lg:col-span-2 md:col-span-3 md:row-span-1",
      imgClassName: "",
      titleClassName: "justify-start",
      img: "/grid.svg",
      spareImg: "/b4.svg",
    },
    {
      id: 5,
      title: t("gridItems.4.title"),
      description: t("gridItems.4.description"),
      className: "md:col-span-3 md:row-span-2",
      imgClassName: "absolute right-0 bottom-0 md:w-96 w-60",
      titleClassName: "justify-center md:justify-start lg:justify-center",
      img: "/b5.svg",
      spareImg: "/grid.svg",
    },
    {
      id: 6,
      title: t("gridItems.5.title"),
      description: t("gridItems.5.description"),
      className: "lg:col-span-2 md:col-span-3 md:row-span-1",
      imgClassName: "",
      titleClassName: "justify-center md:max-w-full max-w-60 text-center",
      img: "",
      spareImg: "",
    },
  ];

  const projects = [
    {
      id: 1,
      title: t("projects.0.title"),
      des: t("projects.0.des"),
      img: "/FinAcro.webp",
      iconLists: ["/next.svg", "/ts.svg", "/re.svg"],
      link: "https://hpxix-stocks.vercel.app/",
    },
    {
      id: 2,
      title: t("projects.1.title"),
      des: t("projects.1.des"),
      img: "/rafraf.webp",
      iconLists: ["/next.svg", "/ts.svg", "/re.svg", "/dock.svg"],
      link: "https://rafraf.com",
    },
    {
      id: 3,
      title: t("projects.2.title"),
      des: t("projects.2.des"),
      des1: t("projects.2.des1"),
      img: "/globCrm.webp",
      iconLists: ["/re.svg", "/ts.svg", "/next.svg"],
      link: "https://glob-refine-git-master-hpxixs-projects.vercel.app/",
    },
    {
      id: 4,
      title: t("projects.3.title"),
      des: t("projects.3.des"),
      img: "/nayalco.webp",
      iconLists: ["/re.svg", "/ts.svg"],
      link: "https://nayalco.com",
    },
  ];

  const testimonials = [
    {
      quote: t("testimonials.0.quote"),
      name: t("testimonials.0.name"),
      title: t("testimonials.0.title"),
    },
    {
      quote: t("testimonials.1.quote"),
      name: t("testimonials.1.name"),
      title: t("testimonials.1.title"),
    },
    {
      quote: t("testimonials.2.quote"),
      name: t("testimonials.2.name"),
      title: t("testimonials.2.title"),
    },
  ];

  const companies = [
    {
      id: 1,
      name: t("companies.0.name"),
      img: "/cloud.svg",
      nameImg: "/cloudName.svg",
    },
    {
      id: 2,
      name: t("companies.1.name"),
      img: "/app.svg",
      nameImg: "/appName.svg",
    },
    {
      id: 3,
      name: t("companies.2.name"),
      img: "/host.svg",
      nameImg: "/hostName.svg",
    },
    {
      id: 4,
      name: t("companies.3.name"),
      img: "/s.svg",
      nameImg: "/streamName.svg",
    },
    {
      id: 5,
      name: t("companies.4.name"),
      img: "/dock.svg",
      nameImg: "/dockerName.svg",
    },
  ];

  const Pricing = [
    {
      id: 1,
      title: t("Pricing.0.title"),
      desc: t("Pricing.0.desc"),
      perk: t("Pricing.0.perk"),
      perk2: t("Pricing.0.perk2"),
      perk3: t("Pricing.0.perk3"),
      perk4: t("Pricing.0.perk4"),
      perk5: t("Pricing.0.perk5"),
      perk6: t("Pricing.0.perk6"),
      price: t("Pricing.0.Price"),
      className: "md:col-span-2",
      thumbnail: "/exp1.svg",
    },
    {
      id: 2,
      title: t("Pricing.1.title"),
      desc: t("Pricing.1.desc"),
      perk: t("Pricing.1.perk"),
      perk2: t("Pricing.1.perk2"),
      perk3: t("Pricing.1.perk3"),
      perk4: t("Pricing.1.perk4"),
      perk5: t("Pricing.1.perk5"),
      perk6: t("Pricing.1.perk6"),
      perk7: t("Pricing.1.Perk7"),
      price: t("Pricing.1.Price"),
      className: "md:col-span-2",
      thumbnail: "/exp2.svg",
    },
    {
      id: 3,
      title: t("Pricing.2.title"),
      desc: t("Pricing.2.desc"),
      perk: t("Pricing.2.perk"),
      perk2: t("Pricing.2.perk2"),
      perk3: t("Pricing.2.perk3"),
      perk4: t("Pricing.2.perk4"),
      perk5: t("Pricing.2.perk5"),
      perk6: t("Pricing.2.perk6"),
      perk7: t("Pricing.2.Perk7"),
      perk8: t("Pricing.2.Perk8"),
      perk9: t("Pricing.2.Perk9"),
      perk10: t("Pricing.2.Perk10"),
      price: t("Pricing.2.Price"),
      className: "md:col-span-2",
      thumbnail: "/exp3.svg",
    },
  ];
  const socialMedia = [
    {
      id: 1,
      img: "/git.svg",
      link: "https://github.com/hpxix",
    },
    {
      id: 2,
      img: "/link.svg",
      link: "https://www.linkedin.com/in/hassan-altahann/",
    },
  ];
  const heroData = [
    {
      id: "0",
      main: t("Hero.0.main"),
      intro: t("Hero.0.main"),
      button: t("Hero.0.button"),
    },
  ];

  return {
    navItems,
    gridItems,
    projects,
    testimonials,
    companies,
    Pricing,
    socialMedia,
    heroData,
  };
}
